import React, { FC } from "react";
import styled from "styled-components";
import { colors } from "@pepdirect/ui/variables";
import { FulfillmentItem } from "./Item";
import { SubmittedOrderForOrderConfirmationQuery } from "services/graphql/generated";

const StyledNote = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius || "10px"};
  background-color: ${({ theme }) =>
    theme.page?.backgroundColor ? "white" : colors.lightGray};
  padding: 10px 20px;
`;

interface FulfillmentsProps {
  fulfillments: NonNullable<
    SubmittedOrderForOrderConfirmationQuery["submittedOrder"]
  >["fulfillments"];
}

export const Fulfillments: FC<FulfillmentsProps> = ({ fulfillments }) => (
  <>
    {!fulfillments || fulfillments.length === 0 ? (
      <StyledNote>
        Please note that in order to ensure faster delivery, one order may
        consist of multiple packages delivered on different days.
      </StyledNote>
    ) : (
      <>
        {fulfillments.map((fulfillment) => (
          <FulfillmentItem fulfillment={fulfillment} key={fulfillment.id} />
        ))}
      </>
    )}
  </>
);
